import { Module } from '@nestjs/common';
import { UsersService } from './users.service';
import { UsersController } from './users.controller';
import { UsersEntity } from '@crm/dto';
import { TypeOrmModule } from '@nestjs/typeorm';
import { GuardsModule } from '../guards/guards.module';
import { SupabaseModule } from '../supabase/supabase.module';

@Module({
  controllers: [UsersController],
  providers: [UsersService],
  imports: [TypeOrmModule.forFeature([UsersEntity]), GuardsModule, SupabaseModule],
  exports: [UsersService],
})
export class UsersModule {}
